import { fileUrl } from '../../utils/formatters';

export default function Avatar({ src, name = '?', lg }) {
  const url = fileUrl(src);
  const cls = `avatar${lg ? ' lg' : ''}`;
  if (url) return <img className={cls} src={url} alt={name} />;
  const initials = name
    .split(' ')
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
  return <div className={`${cls} ph`}>{initials || '?'}</div>;
}
